import { faCopy, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClipboardJS from "clipboard";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import typescript from "react-syntax-highlighter/dist/esm/languages/hljs/typescript";
import { a11yLight, dracula } from "react-syntax-highlighter/dist/esm/styles/hljs";
import VisibilitySensor from "react-visibility-sensor";
import Spacer from "../Utils/Spacer";
import { Context } from "../../context";
import classes from "./About.module.css";

const AboutHome = () => {
    const codeRef = useRef(null);
    SyntaxHighlighter.registerLanguage("typescript", typescript);
    const { debug, lang } = useContext(Context);

    const [isVisible, setIsVisible] = useState(false);
    const [age, setAge] = useState(false);

    const changeVisibility = (isVisibleSensor) => {
        if (isVisibleSensor && isVisible === false) {
            setIsVisible(true);
        }
    };

    const calculateAge = (dateOfBirth) => {
        const now = Date.now();
        const ageInMillis = now - dateOfBirth;
        const ageInSeconds = ageInMillis / 1000;
        const ageInYears = ageInSeconds / (365.25 * 24 * 60 * 60);
        return Math.floor(ageInYears);
    };

    function convertToHexadecimal(number) {
        return number.toString(16).toUpperCase();
    }

    useEffect(() => {
        const decimalNumber = calculateAge(293820400000);
        const hexadecimalValue = convertToHexadecimal(decimalNumber);
        setAge(hexadecimalValue);
    }, []);

    const code = `
      const developer: PersonalData = {
        name: "Davide",
        surname: "Balice",
        email: "davide.balice@gmail.com",
        dateOfBirthTimestamp: 294504263,
        ageHex: ${age},
        location: {
          name: "Reggio Calabria",
          coordinates: {
            latitude: 38.11058724041668,
            longitude: 15.645301603328178,
          },
        },
        skills: [
          "Php",
          "Laravel",
          "Symfony",
          "Node",
          "Spring",
          "React",
          "Angular",
          "JavaScript",
          "TypeScript",
          "Three.js",
        ],
      };
    `;

    useEffect(() => {
        new ClipboardJS(codeRef.current);
    }, []);

    return (
        <section id="about" className={classes.bgCode + " section p_zero"}>
            {/* SVG Decorations */}
            {/* SVG Decorations */}
            <svg className={classes.svgDecoration} width="300" height="300" style={{ top: '5%', left: '-20px', opacity: 0.05 }} viewBox="0 0 100 100">
                {/* Programming Tag symbol </> */}
                <path d="M25 50 L10 50 L25 35 M10 50 L25 65" stroke="white" strokeWidth="2" fill="none" />
                <path d="M45 80 L65 20" stroke="white" strokeWidth="2" fill="none" />
                <path d="M75 50 L90 50 L75 35 M90 50 L75 65" stroke="white" strokeWidth="2" fill="none" />
            </svg>
            <svg className={classes.svgDecoration} width="350" height="350" style={{ bottom: '-5%', right: '-5%', opacity: 0.05 }} viewBox="0 0 100 100">
                {/* Curly Braces { } */}
                <text x="50%" y="60%" textAnchor="middle" fill="white" fontSize="80" fontFamily="monospace" fontWeight="bold">{`{ }`}</text>
            </svg>


            <Spacer height="100" />
            <div className="container">
                <div className="row gy-5 align-items-center">
                    <VisibilitySensor
                        onChange={changeVisibility}
                        partialVisibility
                        delayedCall
                    >
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            animate={{
                                opacity: isVisible ? 1 : 0,
                                x: isVisible ? 0 : -50,
                            }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            className="col-lg-7 col-xl-7 text-justify text-lg-start"
                            style={{ paddingRight: "40px", zIndex: 2 }}
                        >
                            <div className={classes.magicBox}>
                                <div className={classes.titleBar}>
                                    <div className={classes.dots}>
                                        <div className={`${classes.dot} ${classes.dotRed}`}></div>
                                        <div className={`${classes.dot} ${classes.dotYellow}`}></div>
                                        <div className={`${classes.dot} ${classes.dotGreen}`}></div>
                                    </div>
                                    <div className={classes.tab}>
                                        <FontAwesomeIcon icon={faUser} className={classes.tabIcon} /> Profile.js
                                    </div>
                                </div>
                                <div className={classes.magicBoxBody}>
                                    {lang === "en" && (
                                        <>
                                            <div className={classes.devPreTitle}>
                                              <span className={classes.devPrompt}>$</span>
                                              <span className={classes.devCmd}>cat profile.js</span>
                                              <span className={classes.devCursor} />
                                            </div>
                                            <h2 className={`text-7 fw-600 mb-3 ${classes.textGlow}`} style={{ lineHeight: "1.56" }}>
                                                I'm <span className="text-primary">Davide Balice</span><br />
                                                <span style={{ fontSize: '0.65em', fontWeight: 500, opacity: 0.85 }}>a full stack web developer</span>
                                            </h2>
                                            {/* Divider Removed */}
                                            <p className="text-4 text-white-50">
                                                I've been in the industry for + than 15 years, I started
                                                with the php, mysql and javascript stack, but have been
                                                exploring new technologies and frameworks for the past few
                                                years.
                                                <br />
                                                <br />I worked on several projects in different fields, from
                                                the creation of websites to the creation of complex
                                                applications. My passion for programming constantly pushes
                                                me to learn new technologies. I like working in a team and
                                                sharing my knowledge by collaborating to achieve common
                                                goals.
                                            </p>
                                        </>
                                    )}
                                    {lang === "it" && (
                                        <>
                                            <div className={classes.devPreTitle}>
                                              <span className={classes.devPrompt}>$</span>
                                              <span className={classes.devCmd}>cat profile.js</span>
                                              <span className={classes.devCursor} />
                                            </div>
                                            <h2 className={`text-7 fw-600 mb-3 ${classes.textGlow}`}>
                                                Sono <span className="text-primary">Davide Balice</span><br />
                                                <span style={{ fontSize: '0.65em', fontWeight: 500, opacity: 0.85 }}>un full stack web developer</span>
                                            </h2>
                                            {/* Divider Removed */}
                                            <p className="text-4 text-white-50">
                                                Sono nel settore da più di 15 years, ho iniziato con lo stack
                                                php, mysql e javascript, ma negli ultimi anni sono passato
                                                ai moderni framework richiesti dal mercato.
                                                <br />
                                                <br />
                                                Ho lavorato a diversi progetti in diversi campi, dal
                                                creazione di siti web alla creazione di complesse
                                                applicazioni. La mia passione per la programmazione mi
                                                spinge costantemente ad imparare nuove tecnologie. Mi piace
                                                lavorare in squadra e condividere le mie conoscenze
                                                collaborando per raggiungere obiettivi comuni.
                                            </p>
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="brands-grid mt-5">
                                <div className="row">
                                    <div className="col-4">
                                        <div className="text-center">
                                            <h4 className="text-9 text-white mb-0 fw-bold">15+</h4>
                                            <p className="mb-0 text-white-50 small">Years Exp.</p>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="text-center">
                                            <h4 className="text-9 text-white mb-0 fw-bold">100+</h4>
                                            <p className="mb-0 text-white-50 small">Clients</p>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="text-center">
                                            <h4 className="text-9 text-white mb-0 fw-bold">100+</h4>
                                            <p className="mb-0 text-white-50 small">Projects</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </VisibilitySensor>

                    <VisibilitySensor
                        onChange={changeVisibility}
                        partialVisibility
                        delayedCall
                    >
                        <motion.div
                            initial={{ opacity: 0, x: 50, rotateY: 90 }}
                            animate={{
                                opacity: isVisible ? 1 : 0,
                                x: isVisible ? 0 : 50,
                                rotateY: isVisible ? 0 : 30
                            }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            className={`col-lg-5 col-xl-5 ${classes.perspectiveContainer}`}
                        >
                            <div className={classes.monitorBezel}>
                                <div className={classes.codeBox3D}>
                                    <div className={classes.codeTop}>
                                        <span className={classes.copyText}>aboutMe.tsx</span>
                                        <button
                                            className={classes.copyButton}
                                            ref={codeRef}
                                            data-clipboard-text={code}
                                        >
                                            <FontAwesomeIcon icon={faCopy} />
                                            {lang === "en" ? " Copy code" : " Copia codice"}
                                        </button>
                                    </div>
                                    <SyntaxHighlighter
                                        language="typescript"
                                        style={dracula} // Dark theme for code
                                        showLineNumbers
                                        className={classes.SyntaxHighlighter}
                                        customStyle={{ background: '#282a36', margin: 0, padding: '20px', fontSize: '0.85rem' }} // Match dracula bg
                                    >
                                        {code.trim()}
                                    </SyntaxHighlighter>
                                </div>
                                {/* Stand Removed */}
                            </div>
                            {/* Background border removed per request about 'orange line' */}
                        </motion.div>
                    </VisibilitySensor>
                </div>

            </div>

            <Spacer height="100"></Spacer>
        </section>
    );
};

export default AboutHome;
